import { render } from "./GalleryExhibition.vue?vue&type=template&id=1ab499c0&ts=true"
import script from "./GalleryExhibition.vue?vue&type=script&lang=ts"
export * from "./GalleryExhibition.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__